module.exports = __webpack_public_path__ + "img/en-GB.797c586f.svg";